module.exports = __webpack_public_path__ + "img/oa_banner4.7c19c6cd.png";